export const dropDownFields = [
  {
    label: 'Employee',
    value: 'Employee'
  },
  {
    label: 'Business',
    value: 'Business'
  }
]

export const employeeFields = [
  {
    label: '<3L',
    value: '<3L'
  },
  {
    label: '3 - 6L',
    value: '3 - 6L'
  },
  {
    label: '6 - 12L',
    value: '6 - 12L'
  },
  {
    label: '12 - 24L',
    value: '12 - 24L'
  },
  {
    label: '24 - 36L',
    value: '24 - 36L'
  },
  {
    label: '36 - 50L',
    value: '36 - 50L'
  },
  {
    label: '50 - 1Cr',
    value: '50 - 1Cr'
  },
  {
    label: ' > 1Cr',
    value: ' > 1Cr'
  }
]

export const businessFields = [
  {
    label: '<10 lakhs',
    value: '<10 lakhs'
  },
  {
    label: ' <1 crores',
    value: ' <1 crores'
  },
  {
    label: '<5 crores',
    value: '<5 crores'
  },
  {
    label: '>5 crores',
    value: '>5 crores'
  }
]

export const ageDropDownFields = [
  {
    label: '18 to 24',
    value: '18 to 24'
  },
  {
    label: '25 to 35',
    value: '25 to 35'
  },
  {
    label: '36 to 50',
    value: '36 to 50'
  },
  {
    label: '51 to 70',
    value: '51 to 70'
  },
  {
    label: '>70',
    value: '>70'
  }
]

export const ClosedQuestionDropDownFields = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No',
    value: 'No'
  }
]

export const WhichOpportunityAreYouInterestedInFields = [
  {
    label:'Arcade Franchise',
    value:'Arcade Franchise'
  },
  {
    label:'Area License',
    value:'Area License'
  },
  {
    label:'Other',
    value:'Other'
  }
]



// WEBPACK FOOTER //
// ./src/components/ApplyFranchiseComponent/ApplyForFranchiseForm/dropDownFields.js